import { render } from "./ObjSelectZeroField.vue?vue&type=template&id=52fcd042"
import script from "./ObjSelectZeroField.vue?vue&type=script&lang=js"
export * from "./ObjSelectZeroField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__